export const toArray = (obj) => {
  let value = [];
  if (obj) {
    value = Array.isArray(obj) ? obj : [obj];
  }
  return value;
};

const getVariantName = (option) => {
  return option && parseInt(option.variantId, 10) > 1
    ? `${option.variantName} `
    : '';
};

export const getSizeLabel = (option) => {
  const variantName = getVariantName(option);
  if (option?.secondLabel) {
    return `${variantName + option.sfcName}: ${option.name}/${
      option.secondLabel
    }`;
  }
  return option ? `${variantName + option.sfcName}: ${option.name}` : '';
};

const setSizeObjDescription = (size, sizeObj) => {
  if (size.attributeMap.searchFacetOptionName2) {
    sizeObj.description = size.attributeMap.searchFacetOptionName2;
  }
};

const setSizeObjSfcDimName = (style, styleGroup, sizeObj) => {
  if (styleGroup.searchFacetOptionGroupName !== 'size') {
    sizeObj.sfcDimName = `${style.searchFacetOptionGroupName} (${styleGroup.searchFacetOptionGroupName})`;
  }
};

export const setSizeObjAttributeMapProps = (
  sizeObj,
  size,
  style,
  styleGroup
) => {
  if (size.attributeMap) {
    sizeObj.dimId = size.attributeMap.dimensionId;
    sizeObj.dimName = size.attributeMap.searchFacetOptionName2;
    setSizeObjDescription(size, sizeObj);
    sizeObj.attributeMap = size.attributeMap;
    setSizeObjSfcDimName(style, styleGroup, sizeObj);
  }
};

export const applySearchFacetOptionValueVariant = (sizeObj) => {
  if (['OMNI', 'Regular'].indexOf(sizeObj?.variantName) < 0) {
    sizeObj.searchFacetOptionValue = `${sizeObj.variantName} ${sizeObj.searchFacetOptionValue}`;
  }
};

export const updateSelectedSizes = (size, sizeObj, selectedSizes) => {
  if (size.isSelected === 'true') {
    sizeObj.tagDisplayLabel = getSizeLabel(sizeObj);
    selectedSizes.push(sizeObj);
  }
};

export default (facet) => {
  const allSizes = {};
  const sizeOptions = [];
  const selectedSizes = [];

  toArray(facet?.searchFacetOptionGroupList).forEach((style) => {
    toArray(style.searchFacetOptionGroupList).forEach((styleGroup) => {
      toArray(styleGroup.searchFacetOptionGroupList).forEach((variant) => {
        toArray(variant.searchFacetOptionList).forEach((size) => {
          const sizeObj = {};
          sizeObj.isActive = size.isActive;
          if (size.isActive === 'true') {
            sizeObj.searchFacetOptionId = size.searchFacetOptionId;
            sizeObj.variantId = variant.searchFacetOptionGroupId;
            sizeObj.variantName = variant.searchFacetOptionGroupName;
            sizeObj.sfcId = style.searchFacetOptionGroupId;
            sizeObj.sfcName = style.searchFacetOptionGroupName;
            sizeObj.sfcDimName = style.searchFacetOptionGroupName;
            setSizeObjAttributeMapProps(sizeObj, size, style, styleGroup);
            sizeObj.id = size.searchFacetOptionId;
            sizeObj.isSelected = size.isSelected;
            sizeObj.selected = size.isSelected === 'true';
            sizeObj.name = size.searchFacetOptionName;
            sizeObj.searchFacetOptionValue = `${style.searchFacetOptionGroupName}: ${size.searchFacetOptionName}`;
            sizeOptions.push(sizeObj);
            applySearchFacetOptionValueVariant(sizeObj);
            updateSelectedSizes(size, sizeObj, selectedSizes);
          }
        });
      });
    });
  });
  allSizes.sizeOptions = sizeOptions;
  allSizes.selectedSizes = selectedSizes;
  return allSizes;
};
